import styled, { css } from 'styled-components';

export const IconContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;

    dsb-icon::part(icon-asset) {
      width: ${theme.spacing.xxl};
      height: ${theme.spacing.xxl};
    }
  `}
`;
